import { Link } from 'react-router-dom'
import footerLogo from '../../../assets/aexion-logo.webp'

export function Footer() {
  return (
    <footer>
      <div className="footer-logo">
        <img src={footerLogo} alt="AEXION Studios" width="520" height="419" loading="lazy" />
        <p>Um estúdio dedicado a criar universos originais e experiências inesquecíveis.</p>
      </div>
      <div><h2>Produtos</h2><Link to="/agroaprendiz">AgroAprendiz</Link><Link to="/galaxy">Galaxy</Link><Link to="/produtos">Todos os produtos</Link></div>
      <div><h2>Empresa</h2><Link to="/sobre">Sobre nós</Link><Link to="/solucoes">Soluções</Link><Link to="/projetos">Projetos</Link><Link to="/contato">Contato</Link></div>
      <div><h2>Tecnologia</h2><Link to="/demos">Demonstrações</Link><Link to="/solucoes">IA e software</Link><span>AEXION Labs</span></div>
      <div><h2>Legal</h2><Link to="/privacidade">Política de Privacidade</Link><Link to="/termos">Termos de Uso</Link></div>
      <div><h2>Siga-nos</h2><span>Canais oficiais em breve</span></div>
      <p className="copyright">© {new Date().getFullYear()} AEXION Studios. Todos os direitos reservados.</p>
    </footer>
  )
}
